import Script from "next/script";
import { useRouterContext } from "../../contexts";
import { useIsSiteimpact } from "../../utils/partner";
import { isMobile } from "react-device-detect";
import { IS_DEV } from "../../data/js/server-constants"
import cx from "classnames";



const Bidstream = () => {
  if (IS_DEV) return '';
  return (
    <Script
      id="bidstream-tag"
      dangerouslySetInnerHTML={{
        __html: `
    var _hbopts = { alias: '/', type: 'banner', pid: 0 };
    var _hbwrap = _hbwrap || [];
    (function() {
      var hbldr = function (url, resolution, cachebuster, millis, referrer) {
        var s = document.createElement('script'); s.type = 'text/javascript';
        s.async = true; s.src = 'https://' + url + '&resolution=' + resolution +
          '&random=' + cachebuster + '&millis=' + millis + '&referrer=' + referrer;
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      hbldr(
        'ads.bidstreamserver.com/servlet/hbwrap?stack=49&pid=0',
        (window.innerWidth||screen.width)+'x'+(window.innerHeight||screen.height),
        Math.floor(89999999*Math.random()+10000000), new Date().getTime(), encodeURIComponent(
          (window!=top&&window.location.ancestorOrigins)?
            window.location.ancestorOrigins[window.location.ancestorOrigins.length-1]:document.location
        )
      );
    })();
    `,
      }}
    />
  );
};

const useBidstreamVideoTagProps = () => {
  const { isSiteimpact } = useIsSiteimpact();

  if (typeof isSiteimpact === "undefined") return undefined;

  if (isSiteimpact && isMobile) {
    // Mobile SI
    return {
      className: "k-gqACXoWC",
      scriptSrc:
        "//embed.sendtonews.com/player3/embedcode.js?fk=gqACXoWC&cid=14573&offsetx=0&offsety=0&floatwidth=400&floatposition=bottom-left",
    };
  }

  if (isSiteimpact) {
    // Desktop SI
    return {
      className: "k-LnrzW7be",
      scriptSrc:
        "//embed.sendtonews.com/player3/embedcode.js?fk=LnrzW7be&cid=14573&offsetx=0&offsety=0&floatwidth=400&floatposition=bottom-left",
    };
  }

  if (isMobile) {
    // Mobile Rest of sites
    return {
      scriptSrc:
        "//embed.sendtonews.com/player3/embedcode.js?fk=p8tRG47d&cid=14573&offsetx=0&offsety=0&floatwidth=400&floatposition=bottom-left",
      className: "k-p8tRG47d",
    };
  }

  // Desktop Rest of sites
  return {
    scriptSrc:
      "//embed.sendtonews.com/player3/embedcode.js?fk=28q2fTK8&cid=14573&offsetx=0&offsety=0&floatwidth=400&floatposition=bottom-left",
    className: "k-28q2fTK8",
  };
};

export const BidstreamVideoTag = () => {
  const props = useBidstreamVideoTagProps();
  const { asPath } = useRouterContext();
  const hidePlayer =  (
    asPath.includes("sell") ||
    asPath.includes("checkout") ||
    asPath.includes("account") ||
    asPath.includes("chat") ||
    asPath.includes("login")
  )

  if (!props) return null;

  return (
    <>
      <div className={cx("s2nPlayerContainer", { "hidden": hidePlayer })}>
        <div
          className={cx("s2nPlayer", props.className)}
          data-type="float"
        />
      </div>
      <Script
        async
        type="text/javascript"
        src={props.scriptSrc}
        data-type="s2nScript"
      />
    </>
  );
};

export default Bidstream;
